export default __webpack_public_path__ + "static/media/header-bg.d6444320.webp";